



























































































































































































































import { Component, Vue, Provide, Watch, Prop } from "vue-property-decorator";
import {
  ticketClient,
  authorClient,
  client,
  collectionServiceClient,
} from "@/api/index";
import { LawyerLetterListReq } from "@/pbjs/external/ticket/ticket_pb";
import { timeFormat, downloadFile, setValue } from "@/utils/index";
import { pagnition } from "@/utils/commonConfig";
import { setCommon, handleResponse, setPage, errorMsg } from "@/utils/request";
import { Sort, Rank } from "@/pbjs/xcommon/common_pb";
@Component({
  name: "lawyer",
  filters: {
    filterTime(time: number) {
      function addZero(val: any) {
        if (val < 10) {
          val = "0" + val;
        }
        return val;
      }
      if (!time) {
        return time;
      }
      let date: any = new Date(time);
      let month: any = addZero(date.getMonth() + 1);
      let day: any = addZero(date.getDate());
      var yearMonthDay = date.getFullYear() + "-" + month + "-" + day;
      var hoursMS =
        addZero(date.getHours()) +
        ":" +
        addZero(date.getMinutes()) +
        ":" +
        addZero(date.getSeconds());
      return yearMonthDay + " " + hoursMS;
    },
  },
})
export default class lawyerList extends Vue {
  @Provide() private resultData: any = [];
  @Provide() private token: any;
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagnition: any = pagnition;
  @Provide() private pagerCount: number = 0;
  @Provide() private formulaOptions: any = [];
  @Provide() private onEditRow: any = {};
  @Provide() private showDialogType: number = 0;
  @Provide() private ticketSelection: any = [];
  @Provide() private selectedTicketIds: number[] = [];
  @Provide() private selectedAssignUser: any;
  @Provide() private roleOptions: any = [];
  @Provide() private ticketStatusOptions: any = [];
  @Provide() private ticketTypeOptions: any = [];
  @Provide() private lawyerStatusList: any = [];
  @Provide() private radio: string = "";
  @Provide() private visible: boolean = false;
  @Provide() private visible1: boolean = false;
  @Provide() private imgUrl: any = "";
  @Provide() private rules: any = {};
  @Provide() private scopeId: any = {};
  @Provide() private listOrderId: any = {};
  @Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
  @Provide() private ruleForm: any = {
    Orderid: "",
    Customerid: "",
    Customername: "",
    Mobile: "",
    Identity: "",
    Assigntimerange: "",
    Modifytimerange: "",
    PageType: "list",
    NthLawyerLetter: "",
  };
  @Provide() private isGetTicketListActionDone: boolean = false;
  private created() {
    this.lawyerStatusList = [
      0,
      this.$t("ticketLgy.Success"),
      this.$t("ticketLgy.Failed"),
      this.$t("lawyerLxy.LawyerStatus_UNDSend"),
      this.$t("lawyerLxy.LawyerStatus_Cancel"),
    ];
    this.getTicketList();
  }
  private showBIgImg(url: any) {
    this.visible = !this.visible;
    this.imgUrl = url;
  }
  //修改律师韩状态
  private changeStatus(id: number, orderid: string, status: number) {
    if (status == 1) {
      this.visible1 = true;
      this.scopeId = id;
      this.listOrderId = orderid;
    } else {
      this.changeLawyerLetterRequest(id, orderid, status);
    }
  }
  private async changeLawyerLetterRequest(id: number, orderid: string, status: number) {
    let _arg: any = {
      id: id,
      LetterStatus: status,
      orderId: orderid,
      // UserGroupID: Number(localStorage.getItem("usergroupid")),
      sendtype: Number(this.radio),
    };
    const {
      changeLawyerLetterReq,
      changeLawyerLetterRequest,
    }: any = await import("@/request/lawyerList");
    let res = await changeLawyerLetterRequest.handleHttp(
      changeLawyerLetterReq(_arg),
      this
    );
    if (res && res.right) {
      this.$message.success("successfully!");
      this.visible1 = false;
      this.getTicketList();
    } else {
    }
  }

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketList();
  }
  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketList();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketList();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketList();
  }
  private getTicketListAction() {
    this.isGetTicketListActionDone = false;

    this.pageIndex = 1;
    this.getTicketList();
  }
  // 清除数据
  private resetForm(formName: string) {
    const ref: any = this.$refs[formName];
    ref.resetFields();
  }
  private params() {
    let _arg: any = {
      Page: {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      },
      Orderid: this.ruleForm.Orderid,
      Customerid: this.ruleForm.Customerid,
      Customername: this.ruleForm.Customername,
      Mobile: this.ruleForm.Mobile,
      Identity: this.ruleForm.Identity,
      Assigntimerange: "",
      Modifytimerange: "",
      PageType: "list",
      UserGroupID: Number(localStorage.getItem("usergroupid")),
      Sequence: Number(this.ruleForm.NthLawyerLetter),
    };
    if (
      this.ruleForm.Assigntimerange &&
      this.ruleForm.Assigntimerange.length > 0 &&
      this.ruleForm.Assigntimerange[0]
    ) {
      // 开始时间 - 结束时间
      _arg.Assigntimerange =
        timeFormat(this.ruleForm.Assigntimerange[0]) +
        " - " +
        timeFormat(this.ruleForm.Assigntimerange[1]);
    }
    if (
      this.ruleForm.Modifytimerange &&
      this.ruleForm.Modifytimerange.length > 0 &&
      this.ruleForm.Modifytimerange[0]
    ) {
      // 开始时间 - 结束时间
      _arg.Modifytimerange =
        timeFormat(this.ruleForm.Modifytimerange[0]) +
        " - " +
        timeFormat(this.ruleForm.Modifytimerange[1]);
    }
    return _arg;
  }
  // 获取列表
  private async getTicketList() {
    let _arg: any = this.params();
    const {
      getLawyerLetterListReq,
      getLawyerLetterListRequest,
    }: any = await import("@/request/lawyerList");
    let res = await getLawyerLetterListRequest.handleHttp(
      getLawyerLetterListReq(_arg),
      this
    );
    this.isGetTicketListActionDone = false;
    if (res && res.right) {
      this.resultData = res.listList;
      this.resultData.map((item: any) => {
        if (item.sendtype == 0) {
          item.sendtype = "-";
        } else if (item.sendtype == 1) {
          item.sendtype = "WA";
        } else if (item.sendtype == 2) {
          item.sendtype = "Email";
        }
      });
      this.pagerCount = res.pageout.total;
    } else {
    }
  }
  // 导出
  private async getTicketListExport() {
    // getLawyerLetterStatsExcel
    let _arg: any = this.params();
    const {
      exportLawyerLetterListReq,
      exportLawyerLetterListRequest,
    }: any = await import("@/request/lawyerList");
    let response = await exportLawyerLetterListRequest.handleHttp(
      exportLawyerLetterListReq(_arg),
      this
    );
    if (response) {
      if (response.filechunk) {
        let bStr = atob(response.filechunk),
          n = bStr.length,
          unit8Array = new Uint8Array(n);
        while (n--) {
          unit8Array[n] = bStr.charCodeAt(n);
        }
        const blob = new Blob([unit8Array], {
          type: "application/vnd.ms-excel;charset=utf-8",
        });
        downloadFile(blob, response.filename);
      }
    }
  }
}
